import { match } from './selectors';
export function fromRelationshipLegalTerms(legalTermsArray) {
    return legalTermsArray.map((legalTerms)=>{
        switch(legalTerms.type){
            case 'pdf':
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'pdf',
                    origin: 'custom',
                    name: legalTerms.displayName,
                    pdfUniqueName: legalTerms.pdf.pdfName,
                    pdfFileName: legalTerms.pdf.pdfFileName,
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
            case 'richText':
                var _ref;
                var _legalTerms_richText;
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'richText',
                    origin: 'system',
                    name: legalTerms.displayName,
                    richTextId: (_ref = (_legalTerms_richText = legalTerms.richText) === null || _legalTerms_richText === void 0 ? void 0 : _legalTerms_richText.textId) !== null && _ref !== void 0 ? _ref : null,
                    richTextContent: [],
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
            case 'quill':
                var _ref1;
                var _legalTerms_quill;
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'quill',
                    origin: 'custom',
                    name: legalTerms.displayName,
                    richTextId: (_ref1 = (_legalTerms_quill = legalTerms.quill) === null || _legalTerms_quill === void 0 ? void 0 : _legalTerms_quill.textId) !== null && _ref1 !== void 0 ? _ref1 : null,
                    richTextContent: [],
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
        }
    });
}
export function toRelationshipLegalTermsDocuments(legalTerms, contentOverride) {
    return match(legalTerms, {
        pdf: (pdf)=>({
                type: 'pdf',
                displayName: pdf.name,
                legalTermsId: pdf.id,
                termsOfService: {
                    type: 'none'
                },
                pdf: {
                    pdfName: pdf.pdfUniqueName,
                    pdfFileName: pdf.pdfFileName
                }
            }),
        richText: (richText)=>({
                type: 'richText',
                legalTermsId: richText.id,
                displayName: richText.name,
                termsOfService: {
                    type: 'none'
                },
                richText: {
                    textId: null
                }
            }),
        quill: (quill)=>{
            var _quill_richTextId;
            return {
                type: 'quill',
                legalTermsId: quill.id,
                displayName: quill.name,
                termsOfService: {
                    type: 'none'
                },
                quill: {
                    textId: (_quill_richTextId = quill.richTextId) !== null && _quill_richTextId !== void 0 ? _quill_richTextId : null
                },
                contentOverride: contentOverride ? {
                    type: 'custom',
                    custom: {
                        content: contentOverride
                    }
                } : {
                    type: 'none'
                }
            };
        }
    });
}
